import React, { FC } from 'react';
import styled from '@emotion/styled';
import { Text } from '$components/elements/text';
import { useTranslation } from '$hooks';
import { IChild } from '$models';
import { Flex } from '$layouts/flex';
import { ChildSignupLegend } from './style';

type Props = {
    index: number;
    addChild(data: IChild): void;
};

export const ClubSignupChildButton: FC<Props> = ({ index, addChild }) => {
    const { translate } = useTranslation();

    return (
        <AddChildButton onClick={() => addChild({})}>
            <ChildSignupLegend>{translate('signup.child.side') + ' ' + (index + 1)}</ChildSignupLegend>

            <Flex alignItems="center">
                <Text variant="display4" fontWeight="Bold">
                    {'+ ' + translate('signup.child.form.addButton')}
                </Text>
            </Flex>
        </AddChildButton>
    );
};

const AddChildButton = styled.button(({ theme }) => ({
    position: 'relative',
    minHeight: '6.125rem',
    marginBottom: theme.space[4],
    width: '100%',
    background: 'none',
    border: `1px solid ${theme.colors.grey}`,
    borderLeft: `30px solid ${theme.colors.red}`,
    borderRadius: theme.general.borderRadius,
    padding: `${theme.space[3]} ${theme.space[4]} ${theme.space[5]}`,
}));
